import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = ({ component, ...rest }) => {
  const auth = localStorage.getItem("authToken");
  return auth ? <Outlet /> : <Navigate to="/admin" />;
};

export const IsAuthRoute = ({ component, ...rest }) => {
  const auth = localStorage.getItem("authToken");
  return auth ? <Navigate to="/admin/dashboard" /> : <Outlet />;
};
